<section>
  <div class="header">
    <h2>{{ 'i18n.search.searchFilters.filters' | translate }}</h2>
    <span
      data-cy="selected-filters-clear-all"
      (click)="clearAllFilters()"
      *ngIf="!!selectedFilters?.selectedBeans?.length || !!selectedRangeFilter"
    >
      {{ 'i18n.common.clearAll' | translate }}
    </span>
  </div>
  <ng-container *ngFor="let tag of selectedFilters?.selectedBeans">
    <app-usf-chip
      [clickable]="true"
      [type]="chipTypeEnum.selectedFilter"
      [iconConfig]="{
        rightIcon: true,
        color: '#56821f',
        iconUrl: 'assets/images/filter-selected-close.svg'
      }"
      (clickEmitter)="unselectFacetItem(tag.navigationState)"
    >
      {{ tag.label }}
    </app-usf-chip>
  </ng-container>
  <app-usf-chip
    *ngIf="!!selectedRangeFilter"
    [clickable]="true"
    [type]="chipTypeEnum.selectedFilter"
    [iconConfig]="{
      rightIcon: true,
      color: '#56821f',
      iconUrl: 'assets/images/filter-selected-close.svg'
    }"
    (clickEmitter)="unselectRangeFilter()"
  >
    {{ selectedRangeFilter }}
  </app-usf-chip>
</section>
